<template>
  <section
    class="raq-page"
  >
    <div
      v-if="loading"
      class="container"
    >
      <ListLoading />
    </div>
    <div
      v-else
      id="recently-asked-question"
      class="container"
    >
      <div class="section-head">
        <h2 class="section-title">
          Recently Answered Questions
        </h2>

        <router-link
          to="/question"
          class="navigator"
        >
          View all recent Q&A 🡢
        </router-link>
      </div>
      <!--
          vueper-slides wrapper to each slider cards
          vueper-slide represents each testimonials cards
          @see See [Documentation Link](https://antoniandre.github.io/vueper-slides/).
      -->
      <vueper-slides
        class="no-shadow"
        :visible-slides="2"
        autoplay
        :duration="4000"
        :gap="6"
        :arrows="false"
        :dragging-distance="200"
        :breakpoints="{ 768: { visibleSlides: 1, slideMultiple: 1, bullets: false } }"
      >
        <vueper-slide
          v-for="question in questions"
          :key="question.id"
          class="card"
        >
          <template #content>
            <div class="card-head">
              <h5 class="card-title">
                {{ textTrimer(question.title,100) }}
              </h5>
              <span class="date">{{ question.posted_date.date }}</span>
            </div>

            <div class="card-body">
              <p>
                {{ textTrimer(question.description,150) }}
              </p>
            </div>

            <div class="card-foot">
              <!-- <div class="reaction">
                <img
                  src="../../../images/like-icon.svg"
                  alt=""
                >
                <p>352</p>
              </div> -->
              <router-link
                :to="{name:'QuestionDetail', params:{id: question.id}}"
                class="see-more"
              >
                Read responses ({{ question.answer_count }})
              </router-link>
            </div>
          </template>
        </vueper-slide>
      </vueper-slides>
    </div>
  </section>
</template>

<script>
import {VueperSlides, VueperSlide} from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import ListLoading from '@/components/LoadingAnimations/ListLoading.vue'
import {textTrimer} from '@/utils/common'
import {useQuestionStore} from '@/store'
import {onMounted, computed} from 'vue'

export default {
  name: 'RAQS',
  components: {
    VueperSlides,
    VueperSlide,
    ListLoading,
  },
  setup() {
    const store = useQuestionStore()

    onMounted(async () => {
      await store.getRepliedQueries()
    })

    const loading = computed(() => store.loading)
    const questions = computed(() => store.getSlicedRepliedQueries)

    return {
      questions,
      loading,
      textTrimer,
    }
  },
}
</script>
<style lang="scss">
  @import '@/sass/module/home_recently-asked-questions';
</style>
